// ADR 23.9.26u §8 — the one standalone reader.
//
// 23.9.26i needs the same answer for its `surface` and is not yet on disk, so
// by roadmap D1's reader rule (whichever lands second adopts) it imports this
// rather than writing its own. §12 stamps it on every PostHog session.

export type DisplayMode = 'standalone' | 'browser'

/** The window members read: `matchMedia` may be absent (jsdom), `standalone` is iOS's legacy flag. */
export interface DisplayModeWindow {
  matchMedia?: (query: string) => { matches: boolean }
  // `object`, read through a cast below: DOM's `Navigator` has no `standalone`,
  // so a `{ standalone?: boolean }` here would refuse the real `window`.
  navigator: object
}

/** `standalone` when launched from the home screen; an absent `matchMedia` reads as `browser`, never a throw. */
export function displayModeOf(win: DisplayModeWindow): DisplayMode {
  if (win.matchMedia?.('(display-mode: standalone)').matches === true) return 'standalone'
  if ((win.navigator as { standalone?: boolean }).standalone === true) return 'standalone'
  return 'browser'
}
